import { withQuery } from 'ufo'

interface usePaginationPLPOptions {
  pages: Ref<number>
}

export function usePaginationPLP(options: usePaginationPLPOptions) {
  const route = useRoute()
  const { pages } = options
  const path = route.path
  const event = useRequestEvent()
  const initialPage = event?.context.pageInit

  const page = computed(() => {
    const page = Number(route.query.page) || initialPage || 1
    return page
  })

  const { pagesLoaded } = useProductCache()

  const lastLoadedPage = computed(() => {
    if (pagesLoaded.value.length === 0) {
      return 1
    }

    return Math.max(...pagesLoaded.value) || 1
  })

  const firstLoadedPage = computed(() => {
    if (pagesLoaded.value.length === 0) {
      return 1
    }

    return Math.min(...pagesLoaded.value) || 1
  })

  const isEmpty = computed(() => pages.value < 1)

  const nextPageUrl = computed(() => {
    const nextPage = lastLoadedPage.value + 1
    if (nextPage > pages.value) {
      return null
    }

    const nextOrLastPage = Math.min(nextPage, pages.value)
    const nextPageUrl = withQuery(path, { ...route.query, page: nextOrLastPage })
    return nextPageUrl
  })

  const prevPageUrl = computed(() => {
    const prevPage = firstLoadedPage.value - 1
    if (prevPage < 1) {
      return null
    }

    const prevOrFirstPage = Math.max(prevPage, 1)
    const prevPageUrl = withQuery(path, { ...route.query, page: prevOrFirstPage })
    return prevPageUrl
  })

  return {
    // State
    page,

    // Computed
    isEmpty,
    nextPageUrl,
    prevPageUrl,

    pagesLoaded,
  }
}
